<style lang="scss">
.schools {
	&__elipsis {
		display: block;
		min-width: 380px;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}
	&__loading {
		img {
			height: 30px;
			margin-right: 8px;
		}
	}
}
</style>

<template lang="pug">
.schools
    submenu
        schools-submenu
    .content
        page-header
            h1.highlight Schools
        el-table(v-if="Schools && Schools.results.length && filteredSchools.length", v-loading="$apollo.loading", :data="filteredSchools", style="width: 100%")
            el-table-column(prop="name", width="70", label="")
                template(slot-scope="scope")
                    school-status(:school="scope.row")
            el-table-column(prop="name", min-width="400", label="name", :show-overflow-tooltip="true")
                template(slot-scope="scope")
                    router-link(:to="{ name: 'schools.show', params: { school: scope.row.id } }")
                        strong.schools__elipsis {{ scope.row.name }}
            el-table-column(prop="urn", label="Urn", :show-overflow-tooltip="true")
            el-table-column(prop="phase_of_education", min-width="160" label="Phase of education", :show-overflow-tooltip="true")
            el-table-column(prop="mis_name", min-width="130" label="MIS/SIS", :show-overflow-tooltip="true")
            el-table-column(prop="address_postcode", min-width='120', label="Postcode", :show-overflow-tooltip="true")
            el-table-column(prop="country_name", min-width="120", label="Country")
            el-table-column(prop="flag", label="Country", min-width="100", align="center")
                template(slot-scope="scope")
                    flag(:code="scope.row.country_iso_3166_2")
            el-table-column(prop="requested_at", min-width="130" label="Requested", v-if="$route.query.state == 'pending'")
                template(slot-scope="scope")
                    | {{ scope.row.requested_at | time_ago }}
            infinite-loading(slot='append', @infinite='infiniteHandler', force-use-infinite-wrapper='.el-table__body-wrapper', spinner="waveDots")
                div(slot='no-more')
        page(v-else-if="!Schools")
            empty(:info="true", :big="false")
                    .schools__loading
                        img(src="/info.svg")
                        span Loading...
        page(v-else)
            empty We could not find any schools that match the criteria
</template>

<script>
import gql from "graphql-tag";
import SchoolsSubmenu from "./includes/SchoolsSubmenu";
import InfiniteLoading from "vue-infinite-loading";
import { uniq } from "lodash";

export default {
	components: {
		SchoolsSubmenu,
		InfiniteLoading
	},

	data: () => ({
		page: 1
	}),

	computed: {
		filteredSchools() {
			let schools = uniq(this.Schools.results);
			switch (this.$route.query.state) {
				case "offline":
					return schools.filter(s => s.online == false && s.demo == false);
				case "audited":
					return schools.filter(s => s.audit_approval != null && s.approved);
				case "awaitingAudit":
					return schools.filter(s => s.audit_approval == null && s.approved && s.installed);
				default:
					return schools;
			}
		}
	},

	methods: {
		infiniteHandler(state) {
			if (!this.Schools.cursor) return;

			this.page++;

			this.$apollo.queries.Schools.fetchMore({
				variables: {
					state: this.$route.query.state,
					mis: this.$route.query.mis,
					region: this.$route.query.region,
					page: this.page
				},

				updateQuery: (previousResult, { fetchMoreResult }) => {
					fetchMoreResult.Schools.cursor ? state.loaded() : state.complete();

					return {
						Schools: {
							...fetchMoreResult.Schools,
							results: [...previousResult.Schools.results, ...fetchMoreResult.Schools.results]
						}
					};
				}
			});
		}
	},

	apollo: {
		Schools: {
			query: gql`
				query Schools($state: SchoolIndexStateEnum, $mis: String, $region: String, $page: Int) {
					Schools(state: $state, mis: $mis, region: $region, cursor: $page) {
						results {
							id
							name
							phase_of_education
							address_postcode
							country_name
							country_iso_3166_2
							urn
							mis_name
							requested_at
							pending
							company_name
							online
							demo
							audit_approval
							approved
							installed
						}
						cursor
					}
				}
			`,
			fetchPolicy: "cache-and-network",
			variables() {
				return {
					state: this.$route.query.state,
					mis: this.$route.query.mis,
					region: this.$route.query.region,
					page: 1
				};
			}
		}
	}
};
</script>
